<template>
  <!-- `display: contents`: o wrapper existe só porque Vue 2 exige raiz única.
       As sheets do fluxo vivem no <DownloadSheets /> do AppLayout. -->
  <div v-if="visible" class="lesson-download">
    <info-action-button
      :label="label"
      :icon="icon"
      :color="color"
      :border-color="borderColor"
      :progress="state === 'downloading' ? progress : null"
      :bar-color="$theme.primaryColor"
      :disabled="disabled"
      :title="tooltip"
      :width="85"
      @click="onClick"
    />

  </div>
</template>

<script>
import InfoActionButton from '@/components/InfoActionButton';
import downloadActions from '@/mixins/downloadActions';

// Botão de baixar da página da aula. Espelha o ícone do menu lateral: os dois
// usam o mesmo mixin e os mesmos getters, então refletem o mesmo estado sem
// nenhuma sincronização — e o clique passa pelo mesmo fluxo (sheet de qualidade,
// confirmação de rede móvel, confirmação de cancelar/remover).
export default {
  name: 'LessonDownloadButton',
  components: { InfoActionButton },
  mixins: [downloadActions],
  props: {
    enrollId: { type: [String, Number], required: true },
    courseId: { type: [String, Number], default: null },
    learningObject: { type: Object, required: true }
  },
  computed: {
    visible () {
      const lo = this.learningObject;
      if (!lo || !this.enrollId) return false;
      // Aula não publicada / com data futura não baixa — mesmo critério do
      // loRowShowsDownload no menu lateral.
      if (lo.state === 'Unpublished' || lo.releasedDate) return false;
      return this.canDownloadLo(lo, this.courseId);
    },
    state () {
      return this.dlLoStatus(this.enrollId, this.learningObject.id);
    },
    progress () {
      return this.dlLoProgress(this.enrollId, this.learningObject.id) || 0;
    },
    icon () {
      switch (this.state) {
        case 'downloaded': return 'mobile_friendly';
        case 'queued': return 'schedule';
        // Baixando: o rótulo já é a %, e um ícone junto aperta o botão.
        case 'downloading': return null;
        default: return 'save_alt';
      }
    },
    label () {
      switch (this.state) {
        case 'downloaded': return 'Baixado';
        case 'queued': return 'Na fila';
        case 'downloading': return `${Math.round(this.progress)}%`;
        default: return 'Baixar';
      }
    },
    // Cor do tema, igual ao botão de avaliar ao lado. Antes era o verde do ícone
    // do menu lateral, e os dois botões da mesma linha ficavam com linguagens de
    // cor diferentes — verde de sistema vs. roxo do produtor — sem nada que
    // justificasse a distinção pro aluno.
    color () {
      return this.state === 'idle' ? null : this.$theme.primaryColor;
    },
    borderColor () {
      // Só o estado final ganha borda colorida; em trânsito a borda fica neutra
      // pra não competir com o "IA" ativo logo abaixo.
      return this.state === 'downloaded' ? this.$theme.primaryColor : null;
    },
    tooltip () {
      if (this.disabled) return 'Sem conexão — conecte-se para baixar';
      switch (this.state) {
        case 'downloaded': return 'Disponível offline — toque para remover';
        case 'queued': return 'Na fila — toque para cancelar';
        case 'downloading': return 'Baixando — toque para cancelar';
        default: return 'Baixar esta aula para uso offline';
      }
    },
    // Offline só impede COMEÇAR. Cancelar/remover segue permitido — senão uma
    // queda de rede trava o botão e o usuário não consegue nem desistir.
    disabled () {
      if (this.dlIsConnected) return false;
      return this.state === 'idle';
    }
  },
  methods: {
    onClick () {
      if (this.disabled) return;
      this.toggleLoDownload({
        enrollId: this.enrollId,
        lo: this.learningObject
      });
    }
  }
};
</script>

<style scoped>
.lesson-download {
  margin-left: auto;
}
</style>
